import React, { useState, useEffect, useRef } from "react";
import "../style.scss";
import "./style.scss";
import {
 getYoutubePosterImage,
 getRouting,
 formDataGenerator,
 getLang,
} from "../../../../../utils/common";
import { Link, BrowserRouter as Router, Route } from "react-router-dom";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { cornerPodcastApi, cornerSectionOverview } from "../actions";
import SocialShare from "../../../general/socials";

const Podcasts = (props) => {
 const {
   cornerPodcastApi,
   cornerPodcastListData,
   cornerSectionOverview,
   cornerOverviewList,
   location: { pathname },
 } = props;

 const [share, setShare] = useState(false);
 const [cardId, setCardId] = useState(-1);
 const current = pathname.split("/")[2];
 const currentDetail = pathname.split("/")[3];
 const [cornerOverviewTab, setcornerOverviewTab] = useState("");
 const [podcastData, setpodcastData] = useState();
 const [metaData, setMetaData] = useState("");

 useEffect(() => {
  !(cornerPodcastListData && cornerPodcastListData.cornerPodcast) && cornerPodcastApi();
 }, []);

 useEffect(() => {
   if (
     cornerPodcastListData &&
     cornerPodcastListData.cornerPodcast &&
     cornerPodcastListData.cornerPodcast.podcast
   ) {
     setpodcastData(cornerPodcastListData.cornerPodcast.podcast);
   }
   if (
     cornerPodcastListData &&
     cornerPodcastListData.cornerPodcast &&
     cornerPodcastListData.cornerPodcast.meta
   ) {
     setMetaData(cornerPodcastListData.cornerPodcast.meta);
   }
 }, [cornerPodcastListData]);

 useEffect(() => {
  !(cornerOverviewList && cornerOverviewList.cornerOverview) &&  cornerSectionOverview();
 }, []);

 useEffect(() => {
   if (cornerOverviewList && cornerOverviewList.cornerOverview) {
     setcornerOverviewTab(cornerOverviewList.cornerOverview);
   }
 }, [cornerOverviewList]);

 const handleClick = (key) => {
   setCardId(key);
   if (cardId == -1 || cardId === key) setShare((prev) => !prev);
   setShare(true);
 };
 const addTodo = () => {
   setShare(false);
 };

 //dropdown start

 const [isOpen, setIsOpen] = useState(false);
 const dropdownRef = useRef(null);

 const toggleDropDown = () => {
   setIsOpen(!isOpen);
 };

 const handleClickOut = (event) => {
   if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
     setIsOpen(false);
   }
 };

 useEffect(() => {
   document.addEventListener("click", handleClickOut);
   return () => {
     document.removeEventListener("click", handleClickOut);
   };
 }, [isOpen]);

 //dropdown end

 return (
   <>
       <div className="wrapper">
        
         {metaData && metaData !== null && <Helmet>
           <title>{metaData.title ? metaData.title : ""}</title>
           <meta name="description" content={metaData.description ? metaData.description : ""} />
           <meta name="keywords" content={metaData.keywords ? metaData.keywords : ""} />
           <meta property="og:title" content={metaData.og_title ? metaData.og_title : ""} />
           <meta property="og:description" content={metaData.og_description ? metaData.og_description : ""} />
           <meta property="og:image" content={metaData.og_image ? metaData.og_image : ""} />
           <meta property="og:url" content={metaData.og_url ? metaData.og_url : ""} />
         </Helmet>}

         <section className="aboutHead">
           <div className="container">
             <div className="d-flex dropdowncls">
               <div class="dropdown me-auto" ref={dropdownRef}>
                 <div
                   id="dropdownMenuLink"
                   // data-bs-toggle="dropdown"
                   // aria-expanded="false"
                   onClick={toggleDropDown}
                 >
                   <h1>
                     <span>Podcast</span>
                     <img
                       className="ms-2"
                       src="/images/New/redDownArrow.svg"
                       alt=""
                     />
                   </h1>
                 </div>
                 {isOpen && (
                   <ul
                     class="dropdown-body"
                     aria-labelledby="dropdownMenuLink"
                   >
                     {cornerOverviewTab &&
                       cornerOverviewTab.length > 0 &&
                       cornerOverviewTab.map((over, index) =>
                         over.linkName != "Podcast" ? (
                           <li>
                             <a
                               class="dropdown-item fw-bold"
                               href={over.linkName=='Quiz' ? over.linkUrl : over.routeConstant}
                             >
                               {over.linkName}
                             </a>
                           </li>
                         ) : null
                       )}
                   </ul>
                 )}
               </div>
               <nav
                 aria-label="breadcrumb"
                 className="align-self-center breadCrumbCust d-md-inlin"
               >
                 <ol className="breadcrumb mb-0">
                   <li className="breadcrumb-item">
                     <Link to={getRouting(`/`)}>Home</Link>
                   </li>
                   <li className="breadcrumb-item">
                     <Link to={getRouting(`/learners-corner`)}>
                       Learners’ Corner
                     </Link>
                   </li>

                   {/* <li
                     className="breadcrumb-item active breadcolor"
                     aria-current="page"
                   >
                     Podcasts
                   </li> */}
                 </ol>
               </nav>
             </div>
           </div>
         </section>
         <section>
           <div className="container mt-4">
             <div className="row">
               {podcastData &&
                 podcastData.length > 0 &&
                 podcastData.map((item, index) => (
                   <div className="col-lg-6 mb-4">
                     <div className="podcastlist p-4">
                       <div className="row gx-5">
                         <div className="col-md-4">
                           <img
                             className="podimg"
                             src={
                               item.list_thumbnail ? item.list_thumbnail : ""
                             }
                           />
                         </div>
                         <div className="col-md-8 mt-4 mt-md-0">
                           <div className="h-100 d-flex flex-column">
                             <Link
                               to={getRouting(
                                 `/learners-corner/${pathname.split("/")[2]}/${
                                   item.linkurl
                                 }`
                               )}
                             >
                               <h2 className="mb-2">
                                 {item.title ? item.title : ""}
                               </h2>
                             </Link>
                             <p>{item.summary ? item.summary : ""}</p>

                             <div className="d-flex mt-3 mb-3">
                               <p>
                                 Duration :&nbsp;
                                 <span>
                                   {item.duration ? item.duration : ""}
                                 </span>
                               </p>
                               <p className="ms-4">
                                 Episodes :&nbsp;
                                 <span>
                                   {item.total_episodes
                                     ? item.total_episodes
                                     : ""}
                                 </span>
                               </p>
                             </div>
                             <div className="d-flex justify-content-between align-items-center mt-auto">
                               <Link
                                 to={getRouting(
                                   `/learners-corner/${
                                     pathname.split("/")[2]
                                   }/${item.linkurl}`
                                 )}
                               >
                                 <div className="btn btn-primary d-flex justify-content-center align-items-center">
                                   <img src="/images/New/learnNew/podcastbtn.svg" alt="podcast-play-button-icon" />
                                   <p className="ms-2">Listen Now</p>
                                 </div>
                               </Link>
                               <span
                                 className="share"
                                 onClick={() => handleClick(index)}
                               >
                                 <div className="podshare">
                                   <img
                                     src="/images/New/learnNew/podcastshare.svg"
                                     alt="podcast-share-icon"
                                     className="p-2"
                                   />
                                   {share && cardId === index && (
                                     <SocialShare
                                       podName="podcast"
                                       addTodo={addTodo}
                                     />
                                   )}
                                 </div>
                               </span>
                             </div>
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 ))}
             </div>
           </div>
         </section>
       </div>
   </>
 );
};

const mapStateToProps = (state) => ({
 cornerPodcastListData: state.LearnsCorners,
 cornerOverviewList: state.LearnsCorners,
});

const mapDispatchToProps = (dispatch) => ({
 cornerPodcastApi: bindActionCreators(cornerPodcastApi, dispatch),
 cornerSectionOverview: bindActionCreators(cornerSectionOverview, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Podcasts);